export interface ArtifactBase {
  artifactVersion: string;
  deviceId: string;
  fileName: string;
}
